/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Icon from "react-icons-kit";
import { inject, observer } from "mobx-react";
import { close } from "react-icons-kit/ionicons/close";
import AlertBox from "../../common/UI/AlertBox/AlertBox";
import config from "../../../config/config";
import { Document, Page,pdfjs } from 'react-pdf';
import "../../../assets/css/components/Profile/BillingComponent/CreditViewComponent.css";
import { arrowLeft } from "react-icons-kit/fa/arrowLeft";
import { arrowRight } from "react-icons-kit/fa/arrowRight";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const CreditView = inject("sharedStore")(
  observer((props) => {
    const { sharedStore, credits, modalVisibility, closeModalHandler } = props
    const [selectedCredit, setSelectedCredit] = useState("")
    const [creditIndex, setCreditIndex] = useState(0)
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
      if (credits && credits.length > 0) {
        setSelectedCredit(credits[0])
      }
    }, [])


    const loadPrevInvoice = () => {
      setCreditIndex(creditIndex - 1)
      setSelectedCredit(credits[creditIndex - 1])
    };

    const loadNextInvoice = () => {
      setCreditIndex(creditIndex + 1)
      setSelectedCredit(credits[creditIndex + 1])
    };



    const onDocumentLoad = () => {
      sharedStore.showLoader();
    };
    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages);
      sharedStore.hideLoader();
    };
    return (
      <AlertBox
        alertVisibility={modalVisibility}
        closeAlertBoxHandler={closeModalHandler}
        backdrop={false}
        alertclassName="iz-modal credit-view-modal"
      >
        {creditIndex + 1 <= credits.length ? (
          creditIndex + 1 === 1 ? null : (
            <div className="left-arrow">
              <button onClick={loadPrevInvoice} className="back_cusBtn">
                {" "}
                <Icon className="navcus_arrow" size={40} icon={arrowLeft} />
              </button>
            </div>
          )
        ) : null}

        <div className="modal-wrapper wrap-overflow">
          <div className="modal-header">
            {credits && credits.length ? (
              <div className="page-no">
                ({creditIndex + 1}/{credits.length})
              </div>
            ) : null}

            <h3 id="payHeader">Credit Memo</h3>

            <span onClick={closeModalHandler} className="close-icon-wrapper">
              <Icon size={24} icon={close} className="cursor-pointer" />
            </span>
          </div>
          <div className="modal-body credit-flow">
            {selectedCredit && selectedCredit.s3key ? <div className="invoiceBody ">
              <Document
                file={`${config.baseURL}/backend/fetchInvoice?key=${selectedCredit.s3key}`}
                loading={onDocumentLoad}
                onLoadSuccess={onDocumentLoadSuccess}
                // renderMode="canvas"
              >
                <Page pageNumber={pageNumber} />
              </Document>
              {/* <p>Page {pageNumber} of {numPages}</p> */}

            </div> : null}
          </div>
        </div>
        {creditIndex + 1 < credits.length ? (
          <div className="right-arrow">
            <button onClick={loadNextInvoice} className="back_cusBtn">
              {" "}
              <Icon className="navcus_arrow" size={40} icon={arrowRight} />
            </button>
          </div>
        ) : null}
      </AlertBox>
    );
  }))


export default CreditView;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/CreditViewComponent.jsx